import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrashAlt,
  faPlusCircle,
  faChevronDown,
  faSave,
  faExclamationTriangle,
  faTimesCircle,
  faEdit,
  faTimes,
  faCopy,
  faLanguage,
  faSyncAlt,
  faChevronRight,
  faUserCircle,
  faSignOutAlt,
  faSortUp,
  faSortDown,
  faLock,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import editIcon from './edit.svg'
import hamburger from './hamburger.svg'
import hamburgerGray from './hamburger-gray.svg'
import smallPlus from './small-plus.svg'
import curvedArrow from './curved-arrow.svg'

export const DeleteIcon = () => <FontAwesomeIcon icon={faTrashAlt} />
export const AddCircleIcon = () => <FontAwesomeIcon icon={faPlusCircle} />
export const DropDownIcon = () => <FontAwesomeIcon icon={faChevronDown} />
export const SaveIcon = () => <FontAwesomeIcon icon={faSave} />
export const WarningIcon = () => <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'orange' }}/>
export const CloseIcon = () => <FontAwesomeIcon icon={faTimesCircle} />
export const EditIcon = props => <FontAwesomeIcon icon={faEdit} {...props}/>
export const CancelIcon = () => <FontAwesomeIcon icon={faTimes} />
export const CopyIcon = () => <FontAwesomeIcon icon={faCopy} />
export const TranslateIcon = () => <FontAwesomeIcon icon={faLanguage} />
export const EditIconPen = props => <img src={editIcon} alt="edit" {...props}/>
export const Hamburger = props => <img src={hamburger} alt="-" {...props}/>
export const HamburgerGray = props => <img src={hamburgerGray} alt="--" {...props}/>
export const SmallPlus = props => <img src={smallPlus} alt="+" {...props}/>
export const RefreshIcon = props => <FontAwesomeIcon icon={faSyncAlt} />
export const CurvedArrow = props => <img src={curvedArrow} alt="->" {...props}/>
export const ShevronRight = props => <FontAwesomeIcon icon={faChevronRight} />
export const UserIcon = props => <FontAwesomeIcon icon={faUserCircle} />
export const LogoutIcon = props => <FontAwesomeIcon icon={faSignOutAlt} />
export const SortUp = props => <FontAwesomeIcon icon={faSortUp} />
export const SortDown = props => <FontAwesomeIcon icon={faSortDown} />
export const LockIcon = props => <FontAwesomeIcon icon={faLock} />
export const InfoIcon = props => <FontAwesomeIcon icon={faInfoCircle} />

export default {
  DeleteIcon,
  AddCircleIcon,
  WarningIcon,
  SaveIcon,
  DropDownIcon,
  CloseIcon,
  CancelIcon,
  CopyIcon,
  TranslateIcon,
  EditIcon,
  EditIconPen,
  Hamburger,
  HamburgerGray,
  SmallPlus,
  RefreshIcon,
  CurvedArrow,
  ShevronRight,
  UserIcon,
  LogoutIcon,
  SortUp,
  SortDown,
  LockIcon,
  InfoIcon,
}
